<template>
  <section class="gf-entity-members-table">
    <div
      v-if="teams?.items?.length > 0"
      class="users-list-card"
      :class="{ 'mb-3': users?.items?.length > 0 }"
    >
      <div class="card-item --header">
        <span class="card-item__title --first">
          {{ $t('membersWrapper.table.titles.teamsWithAccess') }} {{ formatedEntityType }}
        </span>
        <span class="card-item__title --second">
          {{ $t('membersWrapper.table.titles.roles') }}
        </span>
      </div>
      <gf-entity-members-table-item
        v-for="team in teams?.items"
        :entity-type="entityType"
        :roles="rolesForTeams"
        :item-info="team"
        :is-admin="isAdmin"
        item-type="TEAM"
        :key="team.uuid"
        @role-change="onChange"
        @delete="onDelete"
      />

      <pagination
        v-if="teams?.page && teams?.page?.totalPages > 1"
        :pager="teams?.page"
        @change="emitTeamsPagination"
      />
    </div>

    <div
      v-if="users?.items?.length > 0"
      class="users-list-card"
    >
      <div class="card-item --header">
        <span class="card-item__title --first">
          {{ $t('membersWrapper.table.titles.usersWithAccess') }} {{ formatedEntityType }}
        </span>
        <span class="card-item__title --second">
          {{ $t('membersWrapper.table.titles.roles') }}
        </span>
      </div>
      <gf-entity-members-table-item
        v-for="(user, index) in users?.items"
        :entity-type="entityType"
        :roles="rolesForUsers"
        :item-info="user"
        :is-admin="isAdmin"
        item-type="USER"
        :key="user.uuid"
        @role-change="onChange"
        @delete="onDelete"
        @open-ldap-modal="onOpenLdapModal($event, index)"
      />

      <pagination
        v-if="users?.page && users?.page?.totalPages > 1"
        :pager="users?.page"
        @change="emitUsersPagination"
      />
    </div>
  </section>
</template>

<script>
import GfEntityMembersTableItem from '@/shared-modules/shared-components/wrappers/wrappers-components/entity-members-table/GfEntityMembersTableItem';
import WrapperMessages from '@/shared-modules/shared-components/wrappers/messages/wrapper.messages';
import Pagination from '@/shared-modules/shared-components/shared/pagination';
import { membersTableEntityTypes } from '@/shared-modules/shared-components/wrappers/constants/entity.members.constants';
export default {
  components: { GfEntityMembersTableItem, Pagination },
  name: 'GfEntityMembersTable',
  data() {
    return {
      entityTypesEnum: membersTableEntityTypes
    };
  },
  props: {
    entityType: {
      type: String,
      default: ''
    },
    isAdmin: {
      type: Boolean(),
      default: false
    },
    users: {
      default: () => {
        return {};
      }
    },
    teams: {
      default: () => {
        return {};
      }
    },
    globalRoles: {
      type: Array,
      default: () => {
        return [];
      }
    },
    companyRoles: {
      type: Array,
      default: () => {
        return [];
      }
    },
    baseRoles: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  computed: {
    formatedBaseRoles() {
      return this.baseRoles.map((elem) => {
        return { name: elem };
      });
    },
    rolesForTeams() {
      return { baseRoles: this.formatedBaseRoles };
    },
    rolesForUsers() {
      return {
        baseRoles: this.formatedBaseRoles,
        globalRoles: this.globalRoles,
        companyRoles: this.companyRoles
      };
    },
    formatedEntityType() {
      return this.$i18n.t(`membersWrapper.entityTypes.${this.entityTypesEnum[this.entityType]}`);
    }
  },
  methods: {
    onChange(data) {
      this.$emit('role-change', data);
    },
    onDelete(data) {
      this.$emit('delete', data);
    },
    onOpenLdapModal(data, index) {
      data = { ...data, index: index };
      this.$emit('open-ldap-modal', data);
    },
    emitTeamsPagination(page) {
      this.$emit('teams-pagination', page);
    },
    emitUsersPagination(page) {
      this.$emit('users-pagination', page);
    }
  },
  i18n: {
    messages: WrapperMessages
  }
};
</script>
